import styled from 'styled-components';

export const StyledForm = styled.form`
  .content {
    display: flex;
    justify-content: space-between;
  }

  .wrapped-comp {
    max-width: 430px;
  }
`;
